export default {
  en: {
    lang: 'en',
    title: 'English',
  },
  ru: {
    lang: 'ru',
    title: 'Русский',
  },
  de: {
    lang: 'de',
    title: 'Deutsch',
  },
  fi: {
    lang: 'fi',
    title: 'Suomi',
  },
  br: {
    lang: 'br',
    title: 'Português brasileiro',
  },
};
